import React from 'react';
import { useRaceStore } from '../../stores/raceStore';
import { useTranslation } from '../../utils/i18n';
import { AVAILABLE_MODELS } from '../../utils/pacingModels';
import { Card } from '../ui/Card';
import { GaugeIcon, CheckCircleIcon } from 'lucide-react';
export function PacingModelSelector() {
  const {
    t
  } = useTranslation();
  const {
    settings,
    updateSettings
  } = useRaceStore();
  return <div className="bg-white rounded-2xl border border-[#E8E8ED] shadow-sm overflow-hidden" data-id="element-1084">
      <div className="px-5 py-3.5 border-b border-[#E8E8ED]" data-id="element-1085">
        <div className="flex items-center gap-2.5" data-id="element-1086">
          <GaugeIcon className="h-5 w-5 text-[#FC4C02]" data-id="element-1087" />
          <span className="text-base font-bold text-[#2D2D2D]" data-id="element-1088">
            {t('settings.pacingModel')}
          </span>
        </div>
      </div>

      <div className="p-5 space-y-4" data-id="element-1089">
        <p className="text-sm text-[#6B6B76]" data-id="element-1090">
          {t('settings.pacingModelNote')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1091">
          {AVAILABLE_MODELS.map(model => {
          const isActive = settings.activeModelId === model.id;
          return <button key={model.id} onClick={() => updateSettings({
            activeModelId: model.id
          })} className={`
                  relative text-left p-5 rounded-2xl border-2 transition-all
                  ${isActive ? 'border-[#FC4C02] bg-white shadow-md' : 'border-[#E8E8ED] bg-[#FAFAFA] hover:bg-white hover:border-[#D0D0D8]'}
                `} data-id="element-1092">
                <div className="flex justify-between items-start mb-2" data-id="element-1093">
                  <h4 className={`font-bold ${isActive ? 'text-[#FC4C02]' : 'text-[#2D2D2D]'}`} data-id="element-1094">
                    {model.name}
                  </h4>
                  {isActive && <CheckCircleIcon className="h-5 w-5 text-[#FC4C02]" data-id="element-1095" />}
                </div>
                <p className="text-xs text-[#6B6B76] leading-relaxed" data-id="element-1096">
                  {model.description}
                </p>
              </button>;
        })}
        </div>
      </div>
    </div>;
}